<script setup lang="ts">
import type {Profile} from "~/repository/types";

const {profile} = defineProps<{
  profile: Profile
}>()

const {t} = useI18n();
const {isLoggedIn} = useAuthStore()
const router = useRouter()
const loading = ref(false)

async function sendMessage() {
  if (!isLoggedIn) {
    throw createError({
      statusCode: 401
    })
  }

  loading.value = true
  const data = await $larafetch('chats', {
    method: 'POST',
    body: {
      members: [profile.id],
    },
  });
  loading.value = false
  await router.push({name: 'chats-id', params: {id: data.id}});
}
</script>

<template>
  <Button :pending="loading" variant="outline" @click="sendMessage">{{ t('buttons.send_message') }}</Button>
</template>